{
  "seo": {
    "homeTitle": "Лазурный Берег: афиша, экскурсии и яхты — Riviera To-Do",
    "homeDescription": "Чем заняться на Лазурном Берегу: концерты и спектакли, экскурсии, винные туры, аренда яхт и лодок в Ницце, Каннах, Монако, Антибе и Сен-Тропе.",
    "homeImageAlt": "Эз и побережье Лазурного Берега на закате",
    "toursTitle": "Экскурсии по Лазурному Берегу — из Ниццы, Канн и Монако",
    "toursDescription": "Экскурсии по Лазурному Берегу из Ниццы, Канн, Монако и Антиба: Эз и Монако, деревни Прованса, винные дегустации, морские прогулки и индивидуальные туры.",
    "eventsTitle": "Афиша Лазурного Берега — концерты, спектакли, фестивали",
    "eventsDescription": "Афиша Лазурного Берега: концерты, спектакли, стендап и шоу в Ницце, Каннах, Монако, Антибе и Ментоне — все даты, площадки и билеты в одном месте.",
    "articlesTitle": "Путеводитель по Лазурному Берегу — статьи и советы",
    "articlesDescription": "Путеводитель по Лазурному Берегу: фестивали по сезонам, местные вина и еда, яхты и пляжи, экскурсии и практические советы для поездки в Ниццу, Канны и Монако.",
    "citiesTitle": "Города Французской Ривьеры — Riviera To-Do",
    "citiesDescription": "Ницца, Канны, Монако, Антиб, Сен-Тропе, Ментон и Вильфранш-сюр-Мер: события, экскурсии и развлечения в каждом городе Ривьеры.",
    "boatsTitle": "Аренда лодок и яхт на Лазурном Берегу — с капитаном или без",
    "boatsDescription": "Аренда моторных лодок, РИБов, яхт, парусников и катамаранов на Лазурном Берегу — с капитаном или без, в Каннах, Антибе, Сен-Тропе, Ницце и Монако."
  },
  "app": {
    "logIn": "Войти"
  },
  "nav": {
    "events": "События",
    "tours": "Экскурсии",
    "wineTours": "Винные туры",
    "boats": "Яхты и лодки",
    "hotels": "Отели",
    "articles": "Статьи",
    "cities": "Города"
  },
  "a11y": {
    "language": "Язык",
    "favorites": "Избранное",
    "menu": "Меню",
    "closeMenu": "Закрыть меню",
    "home": "Перейти на главную страницу",
    "back": "Назад",
    "previous": "Предыдущий",
    "next": "Следующий",
    "addFavorite": "Добавить в избранное",
    "removeFavorite": "Удалить из избранного"
  },
  "common": {
    "seeAll": "Смотреть все",
    "wholeRegion": "Весь регион",
    "allCategories": "Все категории",
    "fromPrice": "от {{price}}",
    "inCity": " в {{city}}",
    "notFound": "Страница не найдена.",
    "home": "Главная",
    "showMore": "Показать ещё",
    "loadingMore": "Загрузка…",
    "loadMoreError": "Не удалось загрузить. Попробуйте ещё раз."
  },
  "dates": {
    "today": "сегодня",
    "tomorrow": "завтра",
    "thisWeekend": "в эти выходные",
    "on": "{{date}}"
  },
  "filters": {
    "chooseCity": "Выберите город",
    "filterByDate": "Фильтр по дате",
    "showAllEvents": "Показать все события",
    "resetFilters": "Сбросить фильтры"
  },
  "dateFilters": {
    "alltime": "За всё время",
    "today": "Сегодня",
    "tomorrow": "Завтра",
    "weekend": "В эти выходные",
    "custom": "Выбрать дату"
  },
  "categories": {
    "concerts": "Концерты",
    "theatre": "Театр",
    "exhibitions": "Выставки",
    "parties": "Вечеринки",
    "gastronomy": "Гастрономия",
    "festivals": "Фестивали",
    "sport": "Спорт",
    "family": "Для семьи",
    "cinema": "Кино",
    "other": "Другое"
  },
  "categoryLabels": {
    "concerts": "Концерт",
    "exhibitions": "Выставка",
    "parties": "Вечеринка",
    "theatre": "Театр",
    "gastronomy": "Гастрономия",
    "festivals": "Фестиваль",
    "sport": "Спорт",
    "family": "Для семьи",
    "cinema": "Кино",
    "other": "Другое",
    "fallback": "Событие"
  },
  "categoryNouns": {
    "all": "события",
    "concerts": "концерты",
    "theatre": "спектакли",
    "exhibitions": "выставки",
    "parties": "вечеринки",
    "gastronomy": "гастрономические события",
    "festivals": "фестивали",
    "sport": "спортивные события",
    "family": "события для семьи",
    "cinema": "киносеансы",
    "other": "события"
  },
  "home": {
    "heroTitle": "Французская Ривьера",
    "heroSubtitle": "Все события Ривьеры в одном месте",
    "findEvents": "Найти события",
    "statCities_one": "{{count}} город",
    "statCities_few": "{{count}} города",
    "statCities_many": "{{count}} городов",
    "statCities_other": "{{count}} города",
    "statCategories_one": "{{count}} категория",
    "statCategories_few": "{{count}} категории",
    "statCategories_many": "{{count}} категорий",
    "statCategories_other": "{{count}} категории",
    "eventsNoun_one": "событие",
    "eventsNoun_few": "события",
    "eventsNoun_many": "событий",
    "eventsNoun_other": "события"
  },
  "cityHero": {
    "events_one": "{{display}} событие",
    "events_few": "{{display}} события",
    "events_many": "{{display}} событий",
    "events_other": "{{display}} события",
    "tours_one": "{{display}} экскурсия",
    "tours_few": "{{display}} экскурсии",
    "tours_many": "{{display}} экскурсий",
    "tours_other": "{{display}} экскурсии",
    "boats_one": "{{display}} лодка",
    "boats_few": "{{display}} лодки",
    "boats_many": "{{display}} лодок",
    "boats_other": "{{display}} лодки"
  },
  "events": {
    "heading": "Лучшие {{noun}}{{where}}{{when}}",
    "loading": "Загрузка событий…",
    "empty": "События не найдены.",
    "aboutEvent": "Об этом событии",
    "moreUpcomingCity": "Предстоящие события в {{city}}",
    "moreUpcoming": "Предстоящие события",
    "getTickets": "Купить билеты",
    "free": "Бесплатно",
    "loadingOne": "Загрузка события…",
    "loadError": "Не удалось загрузить событие: {{error}}",
    "notFound": "Событие не найдено.",
    "attributionFnac": "Продажа билетов Fnac Spectacles.",
    "headingRegion": "Афиша Лазурного Берега",
    "headingCity": "Афиша: {{city}}",
    "subheading": "Концерты, выставки, спектакли и фестивали — даты и билеты.",
    "endedBanner": "Это событие уже прошло",
    "endedHint": "Посмотрите предстоящие события ниже.",
    "datesHeading": "Даты и билеты",
    "tickets": "Билеты",
    "moreDates_one": "ещё {{count}} дата",
    "moreDates_few": "ещё {{count}} даты",
    "moreDates_many": "ещё {{count}} дат",
    "moreDates_other": "ещё {{count}} даты",
    "showAllDates": "Показать все даты ({{count}})",
    "showFewerDates": "Свернуть даты",
    "moved": "Страница события переехала.",
    "movedLink": "Перейти на страницу события"
  },
  "tours": {
    "headingRegion": "Экскурсии по Лазурному Берегу",
    "headingCity": "Экскурсии и впечатления в {{city}}",
    "subheading": "Тщательно отобранные впечатления, экскурсии и однодневные поездки — бронирование через Viator.",
    "loading": "Загрузка впечатлений…",
    "empty": "Впечатления не найдены.",
    "badge": "Впечатление",
    "viaViator": "через Viator",
    "book": "Забронировать",
    "aboutExperience": "Об этом впечатлении",
    "moreInCity": "Больше экскурсий в {{city}}",
    "more": "Больше экскурсий",
    "moreWineInCity": "Больше винных туров в {{city}}",
    "moreWine": "Больше винных туров",
    "perPerson": "за человека",
    "reviews_one": "{{count}} отзыв",
    "reviews_few": "{{count}} отзыва",
    "reviews_many": "{{count}} отзывов",
    "reviews_other": "{{count}} отзыва",
    "loadingOne": "Загрузка впечатления…",
    "loadError": "Не удалось загрузить впечатление: {{error}}",
    "notFound": "Впечатление не найдено.",
    "delistedBanner": "Эта экскурсия больше недоступна",
    "delistedHint": "Её больше нельзя забронировать. Посмотрите другие экскурсии ниже."
  },
  "boats": {
    "headingRegion": "Аренда яхт и лодок на Лазурном Берегу",
    "headingCity": "Аренда яхт и лодок в {{city}}",
    "subheading": "Моторные лодки, парусные яхты и яхты — бронирование напрямую через Click&Boat.",
    "loading": "Загрузка лодок…",
    "empty": "Лодки не найдены.",
    "emptyInCity": "Лодки не найдены в {{city}}.",
    "badge": "Аренда лодки",
    "viaClickAndBoat": "через Click&Boat",
    "book": "Забронировать",
    "aboutBoat": "Об этой лодке",
    "moreInCity": "Больше лодок в {{city}}",
    "more": "Больше лодок",
    "perDay": "за день",
    "loadingOne": "Загрузка лодки…",
    "loadError": "Не удалось загрузить лодку: {{error}}",
    "notFound": "Лодка не найдена.",
    "delistedBanner": "Эта лодка больше недоступна",
    "delistedHint": "Её больше нельзя забронировать. Посмотрите другие лодки ниже.",
    "faqHeading": "Аренда лодок на Лазурном Берегу: частые вопросы",
    "facts": {
      "heading": "Характеристики лодки",
      "type": "Тип лодки",
      "port": "Порт отправления",
      "price": "Цена",
      "rating": "Рейтинг",
      "year": "Год постройки",
      "owner": "Владелец",
      "rentalBasis": "Условия аренды",
      "rentalBasisValue": "Посуточно",
      "skipper": "Опция шкипера",
      "skipperValue": "С капитаном или без",
      "passengers": "Пассажиры",
      "passengersValue": "До {{value}}",
      "length": "Длина",
      "lengthValue": "{{value}} м",
      "cabins": "Каюты",
      "berths": "Спальные места",
      "bathrooms": "Санузлы",
      "engine": "Двигатель",
      "engineValue": "{{value}} л. с.",
      "licence": "Права на управление",
      "licenceRequired": "Нужны",
      "licenceNotRequired": "Не нужны",
      "skipperIncluded": "С капитаном",
      "skipperNotAvailable": "Без капитана",
      "onBoard": "На борту"
    },
    "typeLabel": {
      "Motorboat": "Моторная лодка",
      "Sailboat": "Парусная яхта",
      "Catamaran": "Катамаран",
      "RIB": "РИБ",
      "Motor yacht": "Моторная яхта",
      "Houseboat": "Плавучий дом",
      "Boat without licence": "Лодка без лицензии",
      "Jet ski": "Гидроцикл",
      "Sailing yacht": "Парусная яхта"
    },
    "ownerLabel": {
      "professional": "Профессиональный",
      "private": "Частный"
    },
    "template": {
      "title": "Аренда {{type}} в {{city}} — {{name}}",
      "description": "{{name}} — это {{type}}, доступная для аренды в {{city}} на Французской Ривьере, от {{price}} € в день, с капитаном или без.",
      "summary": "Аренда {{type}} в {{city}} от {{price}} €/день — {{name}} на Французской Ривьере.",
      "priceSuffix": "От {{price}} € в день."
    },
    "cityIntro": {
      "nice": "Аренда лодок в Ницце сосредоточена вокруг порта Ниццы и Ангельского залива (Baie des Anges), откуда легко добраться до спокойных вод в сторону мыса Антиб и итальянской границы. Моторные лодки и РИБы — самый популярный выбор для дня на воде, идеальны для поездки в Вильфранш-сюр-Мер или на Леринские острова. Летом (с июня по сентябрь) море наиболее спокойное, а вода — самая тёплая, тогда как весна и начало осени позволяют избежать пикового наплыва туристов в заливе.",
      "cannes": "В Каннах аренда лодок доступна в двух основных точках — в Старом порту у подножия Дворца фестивалей и в соседнем Мандельё-ла-Напуль, откуда до покрытых соснами Леринских островов рукой подать. Флот здесь состоит в основном из моторных яхт и моторных лодок, что отражает гламурную репутацию города, а также множества РИБов, подходящих для семей. Май и июнь — самые оживлённые месяцы из-за кинофестиваля, а июль и август дают наиболее стабильно спокойные условия Средиземного моря для целого дня на воде.",
      "antibes": "Антиб вместе с соседними Гольф-Жуаном и Жуан-ле-Пеном образуют один из самых оживлённых центров водного отдыха на Ривьере, вокруг Порт-Вобан — одной из крупнейших марин Европы. Здесь хорошо представлены и парусные, и моторные лодки, подходящие как для коротких прогулок вдоль мыса Антиб, так и для более долгих переходов к Леринским островам. Относительно защищённые воды залива делают это место удобным для первой аренды без шкипера.",
      "villefranche": "Глубокая и защищённая бухта Вильфранш-сюр-Мер — одна из самых спокойных естественных гаваней побережья — популярная точка отправления в сторону мыса Ферра, Больё-сюр-Мер и итальянской границы. РИБы и моторные лодки лучше всего подходят для коротких живописных маршрутов вокруг мыса. Глубина бухты сохраняет спокойствие воды даже тогда, когда в открытом море волнение усиливается, что особенно удобно для менее опытных арендаторов.",
      "monaco": "Аренда лодок в Монако отправляется как из самого княжества, так и из соседних портов Кап-д'Ай и Монте-Карло, откуда легко добраться вдоль побережья до Ментона и итальянской Ривьеры. Флот здесь скорее премиальный — моторные яхты соседствуют с моторными лодками, что соответствует репутации Монако как гавани для суперъяхт. Спокойное летнее море и короткие переходы подходят как для послеобеденной прогулки с капитаном, так и для более долгого дня в самостоятельном плавании.",
      "menton": "Ментон, самый восточный город Ривьеры, предлагает более спокойную альтернативу Ницце или Каннам для аренды лодок — с отправлением из небольшой городской гавани и соседнего района Ментон-Гараван. Это удобная база для изучения спокойных вод в сторону Монако или для поездки в близлежащие итальянские прибрежные города. Меньшая загруженность подходит как новичкам, так и тем, кто хочет провести день без плотного движения крупных марин.",
      "sttropez": "Сен-Тропе и его более широкий залив — включая Сент-Максим, Гримо, Пор-Гримо, Коголен, Кавалер-сюр-Мер и Раматюэль — образуют крупнейший на Ривьере кластер аренды лодок с самым широким выбором типов судов: от РИБов до парусных и моторных яхт. Защищённый залив Сен-Тропе сохраняет комфортные условия на протяжении большей части сезона, а пляж Памплон и Йерские острова — популярные направления для однодневных поездок. Июль и август — самые загруженные месяцы, поэтому бронировать стоит заранее."
    },
    "faq": [
      {
        "q": "Нужны ли права на управление лодкой, чтобы её арендовать?",
        "a": "Не всегда. Многие лодки на Click&Boat можно арендовать вместе с капитаном, и в этом случае права не требуются — ищите опцию «с капитаном» в каждом объявлении. Аренда без капитана обычно требует действующих прав, соответствующих размеру лодки и мощности двигателя."
      },
      {
        "q": "Требуется ли залог или страховка?",
        "a": "Да. Click&Boat запрашивает залог для большинства аренд, а каждое бронирование включает страхование ответственности, покрывающее лодку и пассажиров на время аренды. Размер залога и условия страхования зависят от конкретной лодки и указаны в объявлении перед бронированием."
      },
      {
        "q": "Что входит в стоимость?",
        "a": "Указанная посуточная цена обычно включает саму лодку и базовое снаряжение безопасности. Топливо, услуги капитана (если выбраны) и дополнительные опции, как правило, оплачиваются отдельно — уточняйте точный состав на странице конкретного объявления на Click&Boat перед бронированием."
      },
      {
        "q": "Можно ли отменить или изменить бронирование?",
        "a": "Условия отмены устанавливает каждый владелец лодки, и они отображаются при оформлении заказа на Click&Boat до оплаты. Многие объявления предлагают бесплатную отмену за определённое число дней до начала аренды — ознакомьтесь с условиями на странице выбранной лодки."
      },
      {
        "q": "Когда сезон аренды лодок на Лазурном Берегу?",
        "a": "Большинство лодок сдаются с весны до осени, пик — июль и август: на эти недели лучше бронировать заранее. Многие владельцы сдают лодки и в мае, июне и сентябре, когда в бухтах и на стоянках спокойнее."
      }
    ],
    "equipment": {
      "air_conditioning": "Кондиционер",
      "generator": "Генератор",
      "bimini": "Тент бимини",
      "sun_pads": "Лежаки для загара",
      "swim_platform": "Купальная платформа",
      "swim_ladder": "Купальная лестница",
      "deck_shower": "Душ на палубе",
      "toilet": "Туалет",
      "kitchen": "Кухня",
      "fridge": "Холодильник",
      "sound_system": "Аудиосистема",
      "tv": "Телевизор",
      "wifi": "Wi-Fi",
      "gps": "GPS-навигатор",
      "autopilot": "Автопилот",
      "bow_thruster": "Носовое подруливающее устройство",
      "anchor_windlass": "Якорная лебёдка",
      "tender": "Шлюпка-тендер",
      "paddle_board": "Сап-борд",
      "snorkelling_gear": "Снаряжение для снорклинга",
      "kayak": "Каяк",
      "water_skis": "Водные лыжи",
      "wakeboard": "Вейкборд",
      "towable": "Буксируемая ватрушка",
      "seabob": "Подводный скутер",
      "fishing_gear": "Рыболовные снасти"
    }
  },
  "crossSell": {
    "headingCity": "Экскурсии и аренда лодок {{inCity}}",
    "heading": "Экскурсии и аренда лодок на Лазурном Берегу"
  },
  "hotels": {
    "eventHeading": "Останетесь на ночь?",
    "nearVenue": "Отели рядом с площадкой {{venue}}",
    "inCity": "Отели {{inCity}}",
    "dates": "{{checkin}} → {{checkout}}",
    "cta": "Смотреть отели",
    "ctaCity": "Смотреть отели {{inCity}}",
    "showMap": "Показать отели на карте",
    "hideMap": "Скрыть карту",
    "mapTitle": "Карта отелей поблизости",
    "sectionHeading": "Где остановиться {{inCity}}",
    "sectionText": "Отели, апартаменты и гостевые дома {{inCity}} — цены на ваши даты на основных сайтах бронирования."
  },
  "articles": {
    "latest": "Последние статьи",
    "loading": "Загрузка статей…",
    "loadError": "Не удалось загрузить статьи: {{error}}",
    "badge": "Статья",
    "readArticle": "Читать статью",
    "loadingOne": "Загрузка статьи…",
    "loadErrorOne": "Не удалось загрузить статью: {{error}}",
    "notFound": "Статья не найдена.",
    "headingRegion": "Путеводитель по Лазурному Берегу",
    "subheading": "Гиды и советы, которые помогут спланировать поездку.",
    "empty": "Статей пока нет.",
    "planHeading": "Спланируйте поездку",
    "moreHeading": "Читайте также",
    "topics": {
      "wine": "Вино",
      "food": "Еда и напитки",
      "festivals": "Фестивали и события",
      "seasonal": "Сезонные гиды",
      "boats": "Яхты и пляжи",
      "tours": "Экскурсии и поездки",
      "culture": "Культура и достопримечательности",
      "practical": "Полезные советы"
    }
  },
  "citiesHub": {
    "heading": "Города Французской Ривьеры",
    "intro": [
      "Французская Ривьера — Лазурный берег — тянется вдоль Средиземного моря от Сен-Тропе на западе до Ментона у итальянской границы. Города стоят близко друг к другу, но у каждого свой характер: Ницца — оживлённая столица, Канны и Монако славятся гламуром, Антиб и Вильфранш-сюр-Мер — небольшие и неторопливые, Сен-Тропе — главное летнее место отдыха, а Ментон — самый спокойный из всех.",
      "Почти все они стоят на одной прибрежной железной дороге, так что удобно жить в одном городе и ездить в остальные на день. Выберите город ниже, чтобы увидеть ближайшие события, экскурсии и развлечения."
    ],
    "taglines": {
      "nice": "Столица Ривьеры: старый город, музеи, аэропорт и поезда во все стороны.",
      "cannes": "Блеск кинофестиваля на Круазетт и морские прогулки на Леринские острова.",
      "monaco": "Казино, Гран-при и суперяхты в гавани — на двух квадратных километрах.",
      "antibes": "Крепостные стены, музей Пикассо и летний джазовый фестиваль в Жуан-ле-Пен.",
      "sttropez": "Шик Старого порта, пляжные клубы Памплоны и виноградники розового вина вокруг.",
      "menton": "Тихий и солнечный край побережья: сады, лимоны и Италия по соседству.",
      "villefranche": "Маленькая гавань на одной из самых глубоких и защищённых бухт Ривьеры."
    },
    "faqHeading": "Города Лазурного берега: частые вопросы",
    "faq": [
      {
        "q": "Где лучше остановиться на Лазурном берегу?",
        "a": "Для первой поездки — в Ницце: здесь аэропорт, самый большой выбор отелей и ресторанов, а поезда идут вдоль побережья в Канны, Антиб, Вильфранш-сюр-Мер, Монако и Ментон. Канны или Антиб подойдут тем, кто хочет город поменьше на западе, Ментон или Вильфранш-сюр-Мер — для более спокойного отдыха на востоке. Сен-Тропе лучше считать отдельным направлением, а не базой: он в стороне от железной дороги и далеко от аэропорта."
      },
      {
        "q": "Можно ли путешествовать по Ривьере без машины?",
        "a": "Да, по большей части. Региональные поезда TER идут вдоль побережья от Канн через Антиб, Ниццу, Вильфранш-сюр-Мер и Монако до Ментона и дальше к итальянской границе — в часы пик по несколько раз в час, а остальное покрывают местные автобусы. Исключение — Сен-Тропе: железнодорожной станции там нет, поэтому добираться придётся на машине, автобусом из Сен-Рафаэля или на кораблике — летом они ходят в том числе из Ниццы и Канн."
      },
      {
        "q": "Сколько ехать до городов от аэропорта Ниццы?",
        "a": "До центра Ниццы — около 25 минут на трамвае. На поезде из Ниццы до Вильфранш-сюр-Мер меньше 10 минут, до Антиба и Монако — около 20–25 минут, до Канн — 30–40 минут, до Ментона — 35–40 минут. До Сен-Тропе от аэропорта около двух часов на машине, а летом из-за пробок часто дольше."
      },
      {
        "q": "Какой город самый спокойный, а какой самый оживлённый?",
        "a": "Самые тихие — Ментон и Вильфранш-сюр-Мер: небольшие, жилые и удобные для отдыха с детьми. В Ницце больше всего событий круглый год — у неё самая насыщенная афиша концертов, спектаклей и фестивалей. Канны и Монако живут ритмом своих главных событий — Каннского кинофестиваля в мае и Гран-при в конце весны, — а Сен-Тропе и Жуан-ле-Пен оживлённее всего в июле и августе."
      },
      {
        "q": "Когда лучше ехать на Лазурный берег?",
        "a": "Конец весны (май–июнь) и начало осени (сентябрь–октябрь) — тепло, но без толп высокого сезона. Июль и август — самые жаркие и людные месяцы, когда растут цены и проходит большинство фестивалей. Зима мягкая и тихая, а в феврале её оживляют Карнавал в Ницце и Праздник лимонов в Ментоне."
      }
    ],
    "imageAlt": "{{city}}, Французская Ривьера"
  },
  "hotelsPage": {
    "heading": "Где остановиться на Лазурном Берегу",
    "seoTitle": "Где остановиться на Лазурном Берегу: города и карта отелей",
    "metaDescription": "Ницца, Канны, Монако, Антиб, Сен-Тропе, Ментон или Вильфранш? В каком городе и районе Лазурного Берега жить — с картой отелей и апартаментов.",
    "intro": [
      "От того, где вы будете жить, поездка на Лазурный Берег зависит сильнее, чем кажется. Побережье тянется от Сен-Тропе на западе до Ментона на границе с Италией, и у каждого города свой характер: в Ницце самый большой выбор жилья и лучший транспорт, Канны и Монако — гламурные (и дорогие) варианты, Антиб и Ментон — небольшие и спокойные, а Вильфранш-сюр-Мер — деревня на берегу одной из самых красивых бухт побережья.",
      "На карте ниже — отели, апартаменты и гостевые дома по всей Ривьере с ценами основных сайтов бронирования; выберите город, чтобы приблизить карту. Ещё ниже — в каком районе каждого города лучше жить и кому он подойдёт."
    ],
    "wholeRiviera": "Весь Лазурный Берег",
    "showOnMap": "Показать на карте",
    "townsHeading": "В каком городе остановиться",
    "cities": {
      "nice": {
        "name": "Ницца",
        "text": "Лучшая база для первой поездки: до аэропорта около 25 минут на трамвае, а поезда идут вдоль побережья в обе стороны. Живите в Старом городе (Вьё-Нис) или рядом с ним, чтобы рестораны и рынки были под рукой, — там оживлённо, но летними ночами шумно. Из отелей на Променад-дез-Англе открывается вид на море; кварталы вокруг авеню Жан-Медсен и вокзала Nice-Ville — практичный и более доступный вариант, а район Порта — тише и с местной атмосферой."
      },
      "cannes": {
        "name": "Канны",
        "text": "Отели сосредоточены вдоль набережной Круазет — от больших дворцов-палас на первой линии до скромных гостиниц в одной-двух улицах от моря. У Сюке, старого квартала на холме над Старым портом, больше характера, а район улицы Антиб и вокзала — центральный и обычно дешевле. Во время Каннского кинофестиваля в мае и крупных выставок цены взлетают, а номера раскупают за несколько месяцев — на эти даты стоит рассмотреть Антиб, Жуан-ле-Пен или Манделье-ла-Напуль."
      },
      "monaco": {
        "name": "Монако",
        "text": "Отелей в Монако немного, и они одни из самых дорогих на побережье, особенно вокруг казино в Монте-Карло. Многие останавливаются сразу за границей, во Франции, — в Босолее, в нескольких минутах ходьбы вверх от Монте-Карло, или в Кап-д’Ай — либо живут в Ницце, в 20–25 минутах на поезде. На уикенд Гран-при бронируйте сильно заранее: в эти дни цены растут по всей восточной Ривьере."
      },
      "antibes": {
        "name": "Антиб",
        "text": "Старый Антиб внутри крепостных стен — место для тех, кто любит гулять пешком: узкие улочки, провансальский рынок и яхты порта Вобан. Жуан-ле-Пен по другую сторону мыса — это песчаные пляжи, ночная жизнь и джазовый фестиваль Jazz à Juan в июле. Сам мыс Кап-д’Антиб — уединённый и дорогой: красиво, но понадобится машина или такси. Вокзалы есть и в Антибе, и в Жуан-ле-Пене."
      },
      "sttropez": {
        "name": "Сен-Тропе",
        "text": "Отели в самом городке небольшие и дорогие, а пик цен приходится на июль и август. Пляжные клубы Пампелона — в нескольких километрах к югу, в Раматюэле, где есть свои отели и виллы. Чтобы сэкономить, остановитесь на другом берегу залива — в Сент-Максиме или Пор-Гримо — и переправляйтесь на рейсовом катере. Поездов нет: нужна машина, автобус из Сен-Рафаэля или лодка."
      },
      "menton": {
        "name": "Ментон",
        "text": "Тихий и солнечный конец побережья — и обычно дешевле, чем Ницца или Канны. Отели стоят вдоль набережной и на улицах под старым городом; Гараван, бухта в сторону итальянской границы, ещё спокойнее. Ментон подходит для неспешного отдыха или долгой зимовки, а поезд идёт до Монако около 10 минут и до Ниццы 35–40 минут."
      },
      "villefranche": {
        "name": "Вильфранш-сюр-Мер",
        "text": "Небольшая портовая деревня, где всего несколько отелей, поэтому большую часть предложения составляют апартаменты и гостевые комнаты. Живите у старого города и порта ради вида на бухту или поищите отели классом выше по соседству — в Больё-сюр-Мер и Сен-Жан-Кап-Ферра. До Ниццы меньше 10 минут на поезде, до Монако — около 15."
      }
    },
    "faqHeading": "Где остановиться на Лазурном Берегу: частые вопросы",
    "faq": [
      {
        "q": "В каком городе Лазурного Берега лучше остановиться?",
        "a": "Для первой поездки — в Ницце: здесь больше всего отелей на любой бюджет, аэропорт рядом, а поезда ходят вдоль всего побережья, так что остальные города легко посмотреть за день. Выбирайте Канны или Монако ради гламура, Антиб — если нужен город поменьше с пляжами, Ментон или Вильфранш-сюр-Мер — для спокойного отдыха, а Сен-Тропе — если главная цель поездки пляжные клубы."
      },
      {
        "q": "Где жить на Лазурном Берегу без машины?",
        "a": "Где угодно на прибрежной железной дороге: вокзалы есть в Каннах, Антибе, Жуан-ле-Пене, Ницце, Вильфранш-сюр-Мер, Монако и Ментоне, а региональные поезда в часы пик ходят несколько раз в час. Выберите отель в пешей доступности от вокзала — и сможете объездить всё побережье без машины. Исключение — Сен-Тропе: железной дороги там нет, понадобится машина, автобус или лодка."
      },
      {
        "q": "Когда отели на Лазурном Берегу дороже всего?",
        "a": "Июль и август — высокий сезон везде. Цены также подскакивают во время крупных событий: Каннского кинофестиваля в мае, Гран-при Монако в конце весны и Карнавала в Ницце в феврале — на эти даты бронируйте за несколько месяцев или живите в соседнем городе. Весной и осенью цены ниже, а погода тёплая; зима — самое дешёвое время, кроме недель карнавала."
      },
      {
        "q": "В Ницце дешевле, чем в Каннах или Монако?",
        "a": "Как правило, да. В Ницце гораздо больше отелей и апартаментов, поэтому вариантов больше при любом бюджете. Монако — самое дорогое место для проживания на побережье, Канны и Сен-Тропе в сезон ненамного дешевле. Ментон и Антиб часто выгоднее, а жить в одном городе и ездить в другой на поезде — распространённый способ сэкономить."
      },
      {
        "q": "Нужно ли платить туристический налог?",
        "a": "Да. Французские коммуны взимают туристический налог (taxe de séjour) за каждого взрослого за ночь; ставку устанавливает город, и в отелях с большим числом звёзд она выше. Часто его оплачивают в отеле, а не включают в цену на сайте, поэтому проверяйте условия бронирования."
      },
      {
        "q": "Как работает бронирование через эту страницу?",
        "a": "Мы сами не продаём номера. Карта и кнопки «Смотреть отели» показывают предложения основных сайтов бронирования через нашего партнёра Stay22; вы выбираете, бронируете и оплачиваете на сайте бронирования, на его условиях. Мы можем получить комиссию с вашего бронирования — для вас цена не меняется."
      }
    ]
  },
  "articlesHub": {
    "intro": [
      "Статьи о Лазурном Береге (Французской Ривьере) — от Сен-Тропе и Канн до Ниццы, Монако и Ментона: когда ехать и какие фестивали застать, что попробовать из местной кухни и вин, как проходит день на яхте и куда съездить на экскурсию. Всё — чтобы спланировать поездку, со ссылками на то, что действительно происходит на месте."
    ],
    "cityGuidesHeading": "Путеводители по городам"
  },
  "cityClimate": {
    "heading": "Погода {{inCity}} по месяцам",
    "columns": {
      "month": "Месяц",
      "high": "Днём, °C",
      "low": "Ночью, °C",
      "sea": "Море, °C",
      "rain": "Дней с дождём"
    },
    "note": "Для купания и прогулок на лодке лучше всего июнь–сентябрь: море прогревается до 20 °C и выше. Весной и осенью мягче и спокойнее — хорошее время для пеших прогулок, поездок по окрестностям и винных туров.",
    "source": "Средняя температура воздуха днём и ночью и число дней с осадками от 1 мм — климатические нормы Météo-France за {{period}} гг., станция: {{station}}. Море — примерная среднемесячная температура у побережья.",
    "stations": {
      "nice": "аэропорт Ниццы",
      "villefranche": "аэропорт Ниццы (ближайшая)",
      "cannes": "Канны",
      "antibes": "Антиб",
      "monaco": "Монако",
      "menton": "Монако (ближайшая)",
      "sttropez": "Коголен (ближайшая)"
    },
    "months": [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь"
    ],
    "inMonth": [
      "в январе",
      "в феврале",
      "в марте",
      "в апреле",
      "в мае",
      "в июне",
      "в июле",
      "в августе",
      "в сентябре",
      "в октябре",
      "в ноябре",
      "в декабре"
    ],
    "faq": {
      "byMonthQ": "Какая погода {{inCity}} по месяцам?",
      "byMonthA": "Зима мягкая, лето жаркое и сухое. Днём в среднем от {{coldHigh}} °C {{coldMonth}} до {{hotHigh}} °C {{hotMonth}}, ночью — от {{coldLow}} °C до {{hotLow}} °C. Чаще всего дожди идут {{wetMonth}} (дней с дождём — около {{wetDays}}), реже всего — {{dryMonth}}.",
      "monthQ": "Какая погода {{inCity}} {{month}}?",
      "monthA": "{{Month}} днём в среднем {{high}} °C, ночью {{low}} °C, море — около {{sea}} °C. Дней с дождём за месяц — около {{rain}}.",
      "swimQ": "Когда {{inCity}} можно купаться в море?",
      "swimA": "С июня по сентябрь море прогревается до 20 °C и выше, в августе — примерно до 24 °C, а в октябре ещё держится около 20 °C. Зимой вода остывает примерно до 13 °C — окунуться можно, но для большинства холодно."
    }
  },
  "cityPages": {
    "nice": {
      "title": "Чем заняться в Ницце",
      "metaDescription": "Концерты, выставки и фестивали на набережной Променад-дез-Англе: планируйте поездку в Ниццу — столицу Французской Ривьеры.",
      "intro": [
        "Ницца — сердце Французской Ривьеры, где Альпы спускаются прямо к Средиземному морю вдоль знаменитой набережной Променад-дез-Англе. Утром стоит побродить среди пастельных фасадов и рыночных рядов Старого города, а днём — отдохнуть на галечных пляжах или заглянуть в музей Матисса и MAMAC.",
        "Помимо открыточных видов, в Ницце круглый год проходят концерты, выставки и фестивали — от яркого Ниццкого карнавала в феврале до джаза под открытым небом летом. Отсюда также удобнее всего исследовать всю Ривьеру: Канны, Монако и горные деревни департамента Приморские Альпы — не дальше часа езды."
      ]
    },
    "cannes": {
      "title": "Чем заняться в Каннах",
      "metaDescription": "От красной дорожки на Круазетт до старого квартала Ле-Сюке: лучшие события, экскурсии и впечатления в Каннах.",
      "intro": [
        "Канны прославили одиннадцать майских дней, когда мировая киноиндустрия собирается у Дворца фестивалей, а по Круазетт тянется красная дорожка. Но гламур города не заканчивается вместе с фестивалем: яхты стоят у отелей в стиле belle époque круглый год, а утренний рынок в старом квартале Ле-Сюке днём сменяется бутиками на бульварах.",
        "Вне фестивального сезона в Каннах регулярно проходят выставки, концерты и гастрономические события, а рядом легко добраться до покрытых соснами островов Лерен. Это компактный город, удобный для прогулок пешком, — и одна из лучших отправных точек для поездок вдоль побережья."
      ]
    },
    "monaco": {
      "title": "Чем заняться в Монако",
      "metaDescription": "Вечера в казино, гонки Гран-при и роскошь belle époque: планируйте визит в Монако с лучшими событиями и экскурсиями Ривьеры.",
      "intro": [
        "Всего два квадратных километра, но, пожалуй, ни одно место на земле не вмещает столько роскоши на такой маленькой площади. Казино Монте-Карло и Княжеский дворец задают тон княжеству, застроенному серпантинами и террасами над морем, а один уик-энд в мае его улицы превращаются в трассу Гран-при Монако — одну из самых сложных гонок Формулы-1.",
        "Когда моторы затихают, Монако предлагает первоклассные выставки, аквариум Океанографического музея и гавань, где стоят одни из крупнейших яхт мира. Отсюда легко доехать до Ниццы или Ментона, и это естественная остановка в любом маршруте по восточной Ривьере."
      ]
    },
    "antibes": {
      "title": "Чем заняться в Антибе",
      "metaDescription": "Бывшая мастерская Пикассо, средневековые крепостные стены и Провансальский рынок: лучшие события и впечатления в Антибе.",
      "intro": [
        "История Антиба видна прямо на его крепостных стенах — старый город, укреплённый ещё греками, а затем Вобаном, огибает гавань, где когда-то работал Пикассо: часть его самых светлых картин сегодня можно увидеть в музее его имени. Провансальский рынок, открытый каждое утро, — один из лучших продуктовых рынков побережья.",
        "Сразу за мысом начинается Жуан-ле-Пен с его джазовым фестивалем и пляжными клубами, а мыс Кап-д'Антиб предлагает одну из самых красивых прибрежных троп Ривьеры. Между галереями старого города и ресторанами современной марины Антиб стоит изучать не спеша."
      ]
    },
    "sttropez": {
      "title": "Чем заняться в Сен-Тропе",
      "metaDescription": "От Старого порта до пляжа Пампелон: планируйте поездку в Сен-Тропе с лучшими событиями, морскими экскурсиями и впечатлениями.",
      "intro": [
        "Когда-то тихая рыбацкая деревня, Сен-Тропе уже шесть десятилетий остаётся синонимом гламура Ривьеры — в Старом порту всё те же пастельные дома, только теперь на фоне яхт, а не рыбацких лодок. На площади Пляс-де-Лис проходит рынок и никогда не прекращается партия в петанк, а с крепости над городом открывается лучший вид на бухту.",
        "К югу от деревни тянется пляж Пампелон — именно здесь родилась культура пляжных клубов Сен-Тропе, и каждое лето она по-прежнему собирает толпы. Приезжайте на день на лодке из Сент-Максима или Ниццы — или останьтесь подольше, чтобы увидеть порт и на рассвете, и на закате."
      ]
    },
    "menton": {
      "title": "Чем заняться в Ментоне",
      "metaDescription": "Лимонные рощи, итальянский свет и Праздник лимона: события, экскурсии и впечатления в Ментоне — самом тихом уголке Ривьеры.",
      "intro": [
        "Прижатый к итальянской границе, Ментон меняет суету Ривьеры на пастельное спокойствие — старый город с крутыми узкими улочками поднимается к барочной базилике, а набережную окружают лимонные и цитрусовые сады, за которые город прозвали «жемчужиной Франции».",
        "Каждый февраль знаменитый Праздник лимона превращает сады на набережной в гигантские скульптуры, целиком собранные из цитрусовых. В остальное время года сады, небольшие музеи и лёгкие пешие маршруты в горы делают Ментон одним из самых спокойных мест на Ривьере — и всего в двух шагах от Монако и итальянской границы."
      ]
    },
    "villefranche": {
      "title": "Чем заняться в Вильфранш-сюр-Мер",
      "metaDescription": "Одна из самых глубоких природных гаваней Средиземноморья, часовня, расписанная Кокто, и цветной старый город: откройте Вильфранш-сюр-Мер.",
      "intro": [
        "Вильфранш-сюр-Мер стоит на одной из самых глубоких природных гаваней Средиземного моря — именно поэтому сегодня здесь бросают якорь круизные лайнеры там, где раньше стояли рыбацкие лодки. Старый город — плотный лабиринт крытых лестниц и пастельных домов, спускающихся прямо к воде, под наблюдением цитадели Сент-Эльм XVI века.",
        "Не пропустите небольшую часовню Сен-Пьер на набережной, расписанную изнутри Жаном Кокто, и прибрежную тропу мыса Кап-Ферра совсем рядом. Это один из самых маленьких городов в этом списке, но его пляж и рестораны у гавани делают его удобной, неспешной базой для знакомства со всей бухтой."
      ]
    }
  },
  "features": {
    "notifications": {
      "title": "Уведомления",
      "desc": "Получайте уведомления о событиях, которые вам интересны"
    },
    "favorites": {
      "title": "Избранное",
      "desc": "Сохраняйте события и создавайте свой личный календарь"
    },
    "map": {
      "title": "Карта событий",
      "desc": "Находите события рядом с вами на интерактивной карте"
    },
    "tickets": {
      "title": "Покупка билетов",
      "desc": "Покупайте билеты напрямую у проверенных партнёров"
    }
  },
  "wineTours": {
    "region": {
      "title": "Винные туры на Лазурном Берегу",
      "seoTitle": "Винные туры и дегустации на Лазурном Берегу",
      "metaDescription": "Лучшие винные туры и дегустации из Ниццы, Канн, Сен-Тропе, Антиба и Монако: розовые вина Кот-де-Прованс, виноградники Белле и Бандоля.",
      "intro": [
        "Лазурный Берег граничит с Провансом — крупнейшим в мире регионом розовых вин. Меньше чем в часе езды от побережья начинаются винодельни Кот-де-Прованс, а у Ниццы даже есть собственный крошечный винодельческий район с контролируемым наименованием — Белле, на холмах над городом.",
        "Ниже — винные туры и дегустации с самыми высокими оценками из главных городов Ривьеры: от двухчасовых мастер-классов до индивидуальных туров на весь день с водителем, чтобы после дегустации никому не пришлось садиться за руль. Все туры бронируются на Viator — там указаны свободные даты, место встречи и условия отмены."
      ],
      "listHeading": "Лучшие винные туры Лазурного Берега",
      "privateHeading": "Индивидуальные винные туры по Лазурному Берегу",
      "sections": [
        {
          "heading": "Винодельческие районы рядом с Ривьерой",
          "paragraphs": [
            "Белле — одно из самых маленьких винодельческих наименований Франции: несколько семейных хозяйств на холмах над Ниццей, с видом на долину Вара. Белые вина здесь делают в основном из сорта роль (верментино), а красные и розовые — из редких местных сортов браке и фоль нуар, которые почти не встречаются в других местах.",
            "Кот-де-Прованс — крупнейшее наименование Прованса, и почти всё вино здесь розовое — сухое и светлое, из гренаша, сенсо и сира. Виноградники тянутся от полуострова Сен-Тропе (Раматюэль, Гассен, Ла-Круа-Вальмер) вглубь департамента Вар — к Ле-Арк-сюр-Аржан, Лоргу и Ла-Моту. Дальше на запад, у Тулона, лежит Бандоль — родина насыщенных красных вин из мурведра, рассчитанных на долгую выдержку."
          ]
        },
        {
          "heading": "Как проходит винный тур",
          "paragraphs": [
            "Самый короткий формат — мастер-класс по дегустации в городе: за пару часов сомелье рассказывает, как пробовать вино, и наливает несколько вин Прованса. Тур на полдня обычно включает одно-два хозяйства — из Ниццы чаще всего в Белле. Тур на целый день — это два-три хозяйства, обед в Провансе и часто остановка в деревне на холме вроде Сен-Поль-де-Ванс.",
            "На винодельне гостям обычно показывают виноградник и погреб, а затем дегустируют несколько вин — иногда с сыром или местными закусками; понравившиеся бутылки можно купить прямо в хозяйстве. Многие небольшие хозяйства принимают гостей только по записи, поэтому тур с готовой программой — самый простой способ попасть на дегустацию."
          ]
        }
      ]
    },
    "cities": {
      "nice": {
        "title": "Винные туры из Ниццы",
        "seoTitle": "Винные туры из Ниццы: Белле и Прованс",
        "metaDescription": "Лучшие винные туры из Ниццы: виноградники Белле над городом, винодельни розовых вин Кот-де-Прованс, индивидуальные туры на день с трансфером из отеля.",
        "intro": [
          "Ницца — один из немногих городов Франции, где в городской черте есть собственное винодельческое наименование — AOC Bellet: несколько семейных хозяйств на холмах к западу от центра, примерно в 20 минутах езды. Белые вина здесь делают в основном из сорта роль (верментино), а также из редких местных сортов — браке и фоль нуар, которые почти не встречаются в других местах.",
          "На целый день туры из Ниццы отправляются на запад, в департамент Вар, к винодельням розовых вин Кот-де-Прованс, часто с остановкой в деревне на холме вроде Сен-Поль-де-Ванс. В большинство туров входит трансфер из отеля, так что дегустировать можно без забот."
        ],
        "listHeading": "Лучшие винные туры из Ниццы",
        "privateHeading": "Индивидуальные винные туры из Ниццы"
      },
      "cannes": {
        "title": "Винные туры из Канн",
        "seoTitle": "Винные туры и дегустации вина из Канн",
        "metaDescription": "Лучшие винные туры и дегустации вина из Канн: винодельни розовых вин Кот-де-Прованс, индивидуальные туры с водителем, поездки в Грас и деревни Прованса.",
        "intro": [
          "Из Канн до винодельческого края Кот-де-Прованс — около часа езды на запад, в окрестности Ле-Арк-сюр-Аржан, Лорга и Ла-Мота. Винные туры из Канн обычно включают два-три хозяйства — часто с посещением шато — и дегустацию розовых, белых и красных вин с комментариями.",
          "Короткие программы сочетают дегустацию с парфюмерными фабриками Граса и деревнями на холмах Прованса. А прямо напротив города, на острове Сент-Онора, монахи Леринского аббатства до сих пор возделывают собственный виноградник — туда легко добраться на катере из Старого порта."
        ],
        "listHeading": "Лучшие винные туры из Канн",
        "privateHeading": "Индивидуальные винные туры из Канн"
      },
      "sttropez": {
        "title": "Винные туры в Сен-Тропе",
        "seoTitle": "Винные туры в Сен-Тропе: розовые вина Прованса",
        "metaDescription": "Лучшие винные туры в Сен-Тропе: винодельни розовых вин Кот-де-Прованс в Раматюэле, Гассене и Ла-Круа-Вальмере — индивидуально или в небольшой группе.",
        "intro": [
          "Сен-Тропе находится в самом сердце края розовых вин. Виноградники покрывают полуостров вокруг Раматюэля, Гассена и Ла-Круа-Вальмера, а некоторые из самых известных хозяйств Прованса — менее чем в 20 минутах езды от порта.",
          "Можно выбрать тур в небольшой группе, индивидуальную поездку по винодельням полуострова или ужин среди виноградников. Лето — высокий сезон, а с конца августа по сентябрь можно застать сбор урожая."
        ],
        "listHeading": "Лучшие винные туры в Сен-Тропе",
        "privateHeading": "Индивидуальные винные туры в Сен-Тропе"
      },
      "antibes": {
        "title": "Винные туры из Антиба",
        "seoTitle": "Винные туры и дегустации из Антиба",
        "metaDescription": "Лучшие винные туры из Антиба и Жуан-ле-Пена: индивидуальные поездки по Провансу, винодельни розовых вин Кот-де-Прованс, дегустации с местными продуктами.",
        "intro": [
          "Антиб, расположенный между Ниццей и Каннами, — удобная отправная точка для винного дня: до виноградников Белле над Ниццей около 30 минут, а до виноделен Кот-де-Прованс — примерно час на запад.",
          "Туры из Антиба — это и прогулка по провансальскому рынку с дегустацией, и индивидуальная поездка на весь день по виноградникам Вара с водителем-гидом и трансфером из отеля в Антибе или Жуан-ле-Пене."
        ],
        "listHeading": "Лучшие винные туры из Антиба",
        "privateHeading": "Индивидуальные винные туры из Антиба"
      },
      "menton": {
        "title": "Дегустации вина и винные туры в Ментоне",
        "seoTitle": "Дегустации вина и винные туры в Ментоне",
        "metaDescription": "Дегустации и винные туры в Ментоне: мастер-классы в небольших группах, виноградники Белле под Ниццей и лигурийские вина сразу за итальянской границей.",
        "intro": [
          "Ментон на границе с Италией известен прежде всего лимонами, но и для знакомства с вином это хорошая база. Прямо в городе проходят дегустации в небольших группах, где можно попробовать вина Прованса и соседней Итальянской Ривьеры, не покидая старый город.",
          "Чуть дальше — виноградники Белле над Ниццей, примерно в 45 минутах, а сразу за границей, в Лигурии, на холмах за Вентимильей делают красное вино Россезе ди Дольчеаккуа."
        ],
        "listHeading": "Лучшие дегустации и винные туры в Ментоне",
        "privateHeading": "Индивидуальные винные туры из Ментона"
      },
      "monaco": {
        "title": "Винные туры из Монако",
        "seoTitle": "Винные туры из Монако: Прованс и Белле",
        "metaDescription": "Винные туры из Монако и Монте-Карло: индивидуальные поездки к винодельням розовых вин Кот-де-Прованс, виноградники Белле над Ниццей и винный край Лигурии.",
        "intro": [
          "У Монако нет собственного винодельческого наименования, но княжество — удобная отправная точка для винного дня: до виноградников Белле над Ниццей около 40 минут, а итальянская граница с лигурийскими виноградниками Дольчеаккуа за ней — ещё ближе.",
          "Чтобы по-настоящему узнать винный Прованс, индивидуальные туры из Монако отправляются на запад к винодельням розовых вин Кот-де-Прованс — обычно с трансфером от отеля или причала яхты и водителем-гидом на весь день."
        ],
        "listHeading": "Лучшие винные туры из Монако",
        "privateHeading": "Индивидуальные винные туры из Монако"
      },
      "villefranche": {
        "title": "Винные туры из Вильфранш-сюр-Мер",
        "seoTitle": "Винные туры из Вильфранш-сюр-Мер",
        "metaDescription": "Винные туры из Вильфранш-сюр-Мер, в том числе на полдня — удобно при стоянке круизного лайнера: виноградники Белле и винодельни розовых вин Прованса.",
        "intro": [
          "Вильфранш-сюр-Мер — одна из самых оживлённых круизных стоянок Средиземноморья, и дегустация вина — одна из самых простых экскурсий из гавани: до виноградников Белле над Ниццей около 30 минут, так что тур на полдня легко укладывается в стоянку лайнера.",
          "Если в распоряжении целый день, туры продолжаются на запад, к винодельням розовых вин Кот-де-Прованс. Если вы прибываете на лайнере, проверьте в описании каждого тура место встречи и время возвращения."
        ],
        "listHeading": "Лучшие винные туры из Вильфранш-сюр-Мер",
        "privateHeading": "Индивидуальные винные туры из Вильфранш-сюр-Мер"
      }
    },
    "faq": [
      {
        "q": "Какие винодельческие регионы можно посетить с Лазурного Берега?",
        "a": "Ближе всего — Белле, небольшой винодельческий район на холмах к западу от Ниццы. Примерно в часе езды на запад от Канн начинаются винодельни розовых вин Кот-де-Прованс — вокруг Ле-Арк-сюр-Аржан, Лорга и на полуострове Сен-Тропе. Некоторые туры на весь день едут дальше, в Бандоль под Тулоном, известный красными винами из мурведра."
      },
      {
        "q": "Какие вина я попробую?",
        "a": "В основном розовые — в Кот-де-Прованс это безусловно главный цвет. Но также свежие белые из сорта роль (верментино) и насыщенные красные в Бандоле и Белле. Обычно на винодельне дегустируют от трёх до пяти вин."
      },
      {
        "q": "Сколько стоит винный тур на Лазурном Берегу?",
        "a": "Самый доступный вариант — мастер-классы по дегустации и туры в небольших группах с оплатой за человека. Индивидуальные туры на весь день с гидом-водителем стоят заметно дороже, и их цена часто указана за всю группу, а не за человека. Актуальная начальная цена указана в каждом туре."
      },
      {
        "q": "Стоит ли брать индивидуальный винный тур?",
        "a": "Для пары групповой тур в небольшой группе обычно обходится дешевле. Индивидуальный тур имеет смысл для семьи или компании, на особый случай или если вы хотите сами выбрать хозяйства: свой водитель-гид, трансфер от места проживания и гибкое расписание. Индивидуальные туры на каждой странице собраны в отдельный блок."
      },
      {
        "q": "Нужна ли машина?",
        "a": "Нет. В большинство туров входит трансфер от отеля, порта или центральной точки встречи, так что дегустировать могут все. Допустимый уровень алкоголя в крови водителя во Франции — 0,5 г/л, поэтому тур с водителем — самый разумный выбор."
      },
      {
        "q": "Когда лучше ехать в винный тур?",
        "a": "Винодельни принимают гостей круглый год, но самый оживлённый период — с весны до осени, а сбор урожая идёт с конца августа до сентября. Многие небольшие хозяйства закрыты по воскресеньям, а зимой некоторые сокращают часы работы — проверяйте доступные даты в каждом туре."
      },
      {
        "q": "Как забронировать и можно ли отменить?",
        "a": "Туры бронируются на Viator — сайт принимает оплату и присылает подтверждение. Во многих турах действует бесплатная отмена за 24 часа до начала — перед бронированием проверьте условия в описании тура."
      }
    ],
    "citiesHeading": "По городу отправления",
    "cityLinksHeading": "Винные туры по городам",
    "groupHeading": "Групповые туры и дегустации",
    "privateIntro": "На индивидуальном туре машина, водитель-гид и программа — только ваши: обычно вас забирают из отеля, виллы или круизного порта, а хозяйства и темп вы выбираете сами. Цена часто указана за группу, а не за человека — уточняйте в каждом предложении, — поэтому такие туры особенно выгодны для семьи или компании друзей.",
    "compare": {
      "note": "Порядок — по оценке и числу отзывов. Цена — текущая стартовая цена на Viator.",
      "tour": "Тур",
      "from": "Отправление",
      "duration": "Длительность",
      "format": "Формат",
      "rating": "Отзывы",
      "price": "Цена от",
      "private": "Индивидуальный",
      "group": "Групповой"
    },
    "allCities": "Весь Лазурный Берег",
    "stats_one": "{{count}} винный тур · от {{price}}",
    "stats_few": "{{count}} винных тура · от {{price}}",
    "stats_many": "{{count}} винных туров · от {{price}}",
    "stats_other": "{{count}} винного тура · от {{price}}",
    "faqHeading": "Винные туры: частые вопросы",
    "loading": "Загрузка винных туров…",
    "empty": "Винных туров пока нет.",
    "allTours": "Все экскурсии и впечатления"
  },
  "boatsHub": {
    "intro": [
      "Моторные лодки, РИБы, моторные яхты, парусники, катамараны и лодки без прав в аренду в портах Лазурного Берега (Французской Ривьеры) — от Сен-Тропе и Канн до Антиба, Ниццы, Монако и Ментона. Аренда на полдня, день или дольше, с капитаном или самостоятельно: в каждом объявлении указаны тип лодки, порт, цена за день и ссылка на бронирование через Click&Boat."
    ],
    "sections": [
      {
        "heading": "Куда отправиться на лодке",
        "paragraphs": [
          "Из Канн совсем недалеко до Леринских островов — Сент-Маргерит и Сент-Онора, а на западе среди красных скал Эстереля прячутся тихие бухты. Из Антиба и Жуан-ле-Пена лодки огибают мыс Антиб, из Ниццы и Вильфранш-сюр-Мер — идут в защищённую бухту Вильфранша и к бухтам мыса Кап-Ферра. Из Сен-Тропе классический маршрут — пляж Пампелон и залив Сен-Тропе, а из Монако — вдоль побережья на восток к мысу Кап-Мартен и Ментону."
        ]
      },
      {
        "heading": "Какую лодку выбрать",
        "paragraphs": [
          "Лодки без прав оснащены небольшим мотором и подходят для коротких спокойных прогулок недалеко от берега. РИБы быстрые и манёвренные — их обычно берут, чтобы добраться до островов и бухт. Моторная лодка — универсальный вариант для семейного дня в море, а моторные яхты чаще арендуют с капитаном — для компаний и особых случаев. Парусники и катамараны — для хождения под парусом; катамаран устойчивый и просторный, поэтому его любят брать на целый день и большой компанией."
        ]
      },
      {
        "heading": "Что важно знать перед выходом в море",
        "paragraphs": [
          "Во Франции для управления лодкой с мотором мощнее 6 л. с. нужны права (для прибрежного плавания — permis côtier); без них выбирайте лодку без прав или аренду с капитаном. В 300-метровой зоне от берега скорость ограничена 5 узлами, а в отмеченные буями зоны для купания у пляжей заходить на лодке нельзя. Море обычно спокойнее утром — планируйте переходы на раннее время и уточняйте прогноз погоды у владельца."
        ]
      }
    ],
    "citiesHeading": "Аренда лодок по городам"
  },
  "boatRental": {
    "cities": {
      "nice": {
        "title": "Аренда лодки в Ницце",
        "seoTitle": "Аренда лодки и яхты в Ницце — с капитаном или без",
        "inCity": "в Ницце"
      },
      "cannes": {
        "title": "Аренда лодки в Каннах",
        "seoTitle": "Аренда лодки и яхты в Каннах — с капитаном или без",
        "inCity": "в Каннах"
      },
      "antibes": {
        "title": "Аренда лодки в Антибе",
        "seoTitle": "Аренда лодки и яхты в Антибе и Жуан-ле-Пене",
        "inCity": "в Антибе"
      },
      "villefranche": {
        "title": "Аренда лодки в Вильфранш-сюр-Мер",
        "seoTitle": "Аренда лодки и яхты в Вильфранш-сюр-Мер",
        "inCity": "в Вильфранш-сюр-Мер"
      },
      "monaco": {
        "title": "Аренда лодки в Монако",
        "seoTitle": "Аренда лодки и яхты в Монако",
        "inCity": "в Монако"
      },
      "menton": {
        "title": "Аренда лодки в Ментоне",
        "seoTitle": "Аренда лодки и яхты в Ментоне — с капитаном или без",
        "inCity": "в Ментоне"
      },
      "sttropez": {
        "title": "Аренда лодки в Сен-Тропе",
        "seoTitle": "Аренда лодки и яхты в Сен-Тропе — с капитаном или без",
        "inCity": "в Сен-Тропе"
      }
    },
    "metaDescription_one": "Аренда лодки {{inCity}}: {{count}} лодка от {{price}} в день, с капитаном или без. Сравните и забронируйте на Click&Boat.",
    "metaDescription_few": "Аренда лодки {{inCity}}: {{count}} лодки от {{price}} в день — моторные лодки, РИБы, яхты и катамараны, с капитаном или без. Бронирование на Click&Boat.",
    "metaDescription_many": "Аренда лодки {{inCity}}: {{count}} лодок от {{price}} в день — моторные лодки, РИБы, яхты и катамараны, с капитаном или без. Бронирование на Click&Boat.",
    "metaDescription_other": "Аренда лодки {{inCity}}: {{count}} лодки от {{price}} в день — моторные лодки, РИБы, яхты и катамараны, с капитаном или без. Бронирование на Click&Boat.",
    "stats_one": "{{count}} лодка · от {{price}} в день",
    "stats_few": "{{count}} лодки · от {{price}} в день",
    "stats_many": "{{count}} лодок · от {{price}} в день",
    "stats_other": "{{count}} лодки · от {{price}} в день",
    "ratingStat": "средний рейтинг {{rating}}/5",
    "typesHeading": "Типы лодок и цены",
    "typeRow_one": "{{count}} лодка · от {{price}}",
    "typeRow_few": "{{count}} лодки · от {{price}} · обычно {{median}} в день",
    "typeRow_many": "{{count}} лодок · от {{price}} · обычно {{median}} в день",
    "typeRow_other": "{{count}} лодки · от {{price}} · обычно {{median}} в день",
    "portsHeading": "Порты отправления",
    "topHeading": "Лодки с лучшим рейтингом {{inCity}}",
    "allHeading": "Все лодки в аренду {{inCity}}",
    "citiesHeading": "Аренда лодок в других городах Ривьеры",
    "allBoats": "Все яхты и лодки в аренду на Ривьере",
    "faqHeading": "Аренда лодки {{inCity}}: частые вопросы",
    "listSeparator": ", ",
    "loading": "Загрузка лодок…",
    "empty": "Лодки не найдены.",
    "typePlural": {
      "Motorboat": "моторные лодки",
      "Sailboat": "парусники",
      "Catamaran": "катамараны",
      "RIB": "РИБы",
      "Motor yacht": "моторные яхты",
      "Houseboat": "плавучие дома",
      "Boat without licence": "лодки без лицензии",
      "Jet ski": "гидроциклы",
      "Sailing yacht": "парусные яхты",
      "other": "другие лодки"
    },
    "faq": {
      "priceQ": "Сколько стоит аренда лодки {{inCity}}?",
      "priceA": "Аренда на день {{inCity}} начинается от {{min}}, а половина лодок в каталоге стоит не больше {{median}} в день. По типам: {{list}}. Топливо, услуги капитана и дополнительные опции обычно оплачиваются отдельно — что входит в цену, указано в каждом объявлении на Click&Boat.",
      "typePrice": "{{type}} — от {{price}}",
      "licenceQ": "Можно ли арендовать лодку без прав {{inCity}}?",
      "licenceYesA_one": "Да — {{inCity}} можно арендовать {{count}} лодку без лицензии, от {{price}} в день: это небольшая лодка с маломощным мотором, для управления которой права не нужны. Любую другую лодку можно взять с капитаном — тогда права тоже не требуются.",
      "licenceYesA_few": "Да — {{inCity}} можно арендовать {{count}} лодки без лицензии, от {{price}} в день: это небольшие лодки с маломощным мотором, для управления которыми права не нужны. Любую другую лодку можно взять с капитаном — тогда права тоже не требуются.",
      "licenceYesA_many": "Да — {{inCity}} можно арендовать {{count}} лодок без лицензии, от {{price}} в день: это небольшие лодки с маломощным мотором, для управления которыми права не нужны. Любую другую лодку можно взять с капитаном — тогда права тоже не требуются.",
      "licenceYesA_other": "Да — {{inCity}} можно арендовать {{count}} лодки без лицензии, от {{price}} в день: это небольшие лодки с маломощным мотором, для управления которыми права не нужны. Любую другую лодку можно взять с капитаном — тогда права тоже не требуются.",
      "licenceNoA": "Сейчас {{inCity}} нет лодок без лицензии, но многие лодки можно арендовать с капитаном — тогда права не нужны. Чтобы самостоятельно управлять моторной лодкой мощнее 6 л. с. во Франции, нужны прибрежные права (permis côtier).",
      "portsQ": "Откуда отправляются арендные лодки {{inCity}}?",
      "portsA": "Лодки {{inCity}} отправляются из: {{list}}. Точное место встречи указано в каждом объявлении.",
      "typesQ": "Какие лодки можно арендовать {{inCity}}?",
      "typesA": "Сейчас {{inCity}} доступны: {{list}}. Моторные лодки и РИБы подходят для прогулки на полдня или день вдоль побережья — самостоятельно или с капитаном; катамараны и моторные яхты обычно арендуют с капитаном, для компаний."
    },
    "detailLink": "Аренда лодки {{inCity}}: цены, права и порты отправления",
    "showAllType": "Показать все {{type}} ({{count}})",
    "showFewer": "Свернуть",
    "typeChipsHeading": "Типы лодок {{inCity}}",
    "typeMeta": "{{countText}} в аренду {{inCity}} от {{price}} в день, обычно {{median}}. Сравните цены и порты отправления и забронируйте на Click&Boat.",
    "typeStats": "{{countText}} · от {{price}} в день · обычно {{median}} в день",
    "typePricesHeading": "Цены за день",
    "typeTopHeading": "{{pluralCap}} с лучшим рейтингом {{inCity}}",
    "typeAllHeading": "Все {{plural}} в аренду {{inCity}}",
    "typeOtherTypesHeading": "Другие лодки {{inCity}}",
    "typeOtherCitiesHeading": "{{pluralCap}} в других городах Ривьеры",
    "typeFaqHeading": "{{title}}: частые вопросы",
    "typePriceA": "Цены на {{plural}} {{inCity}} начинаются от {{min}} в день, а половина стоит {{median}} или меньше. По цене: {{bands}}. Топливо, капитан и дополнительные услуги обычно оплачиваются отдельно — в каждом объявлении на Click&Boat указано, что входит в стоимость.",
    "typePortsQ": "Откуда отправляются {{plural}} {{inCity}}?",
    "typePortsA": "{{pluralCap}} {{inCity}} отправляются из: {{list}}. Точное место встречи указано в каждом объявлении.",
    "typeDetailLink": "{{title}}: цены и порты отправления",
    "typePages": {
      "motorboat": {
        "title": "Аренда моторной лодки {{inCity}}",
        "seoTitle": "Аренда моторной лодки {{inCity}} — с капитаном или без",
        "plural": "моторные лодки",
        "count_one": "{{count}} моторная лодка",
        "count_few": "{{count}} моторные лодки",
        "count_many": "{{count}} моторных лодок",
        "count_other": "{{count}} моторной лодки",
        "intro": "Моторная лодка — самый популярный способ провести день на воде {{inCity}}: ей легко управлять, на ней быстро добраться до соседних бухт и островов, а арендовать её можно с капитаном или без. Ниже — все моторные лодки {{inCity}} на Click&Boat с ценами за день и портами отправления.",
        "priceQ": "Сколько стоит аренда моторной лодки {{inCity}}?",
        "licenceQ": "Нужны ли права, чтобы арендовать моторную лодку {{inCity}}?",
        "licenceA": "Чтобы управлять лодкой самостоятельно, во Франции нужны права (permis côtier) для любого мотора мощнее 6 л. с. — то есть почти для всех лодок здесь. Без прав арендуйте лодку с капитаном (многие владельцы это предлагают) или выберите лодку без прав."
      },
      "rib": {
        "title": "Аренда РИБа {{inCity}}",
        "seoTitle": "Аренда РИБа {{inCity}} — жёстко-надувная лодка на день",
        "plural": "РИБы",
        "count_one": "{{count}} РИБ",
        "count_few": "{{count}} РИБа",
        "count_many": "{{count}} РИБов",
        "count_other": "{{count}} РИБа",
        "intro": "РИБ (жёстко-надувная лодка) — лёгкий, быстрый и устойчивый: классический выбор, чтобы провести день {{inCity}}, переходя от бухты к бухте и останавливаясь искупаться. Ниже — все РИБы {{inCity}} на Click&Boat с ценами и портами отправления.",
        "priceQ": "Сколько стоит аренда РИБа {{inCity}}?",
        "licenceQ": "Нужны ли права, чтобы арендовать РИБ {{inCity}}?",
        "licenceA": "У большинства РИБов мотор намного мощнее 6 л. с., поэтому для самостоятельного управления нужны французские права (permis côtier) или их аналог. Без прав арендуйте РИБ с капитаном."
      },
      "yacht": {
        "title": "Аренда яхты {{inCity}}",
        "seoTitle": "Аренда яхты {{inCity}} — на день с капитаном",
        "plural": "яхты",
        "count_one": "{{count}} яхта",
        "count_few": "{{count}} яхты",
        "count_many": "{{count}} яхт",
        "count_other": "{{count}} яхты",
        "intro": "Моторная или парусная яхта — это день в море {{inCity}} с комфортом: тень на палубе, каюта и место для компании, обычно с профессиональным капитаном на борту. Ниже — все яхты {{inCity}} на Click&Boat с ценами за день и портами отправления.",
        "priceQ": "Сколько стоит аренда яхты на день {{inCity}}?",
        "licenceQ": "Нужны ли права, чтобы арендовать яхту {{inCity}}?",
        "licenceA": "Как правило, нет: яхты почти всегда сдаются с капитаном или экипажем, которые управляют судном. Топливо, капитан и дополнительные услуги часто оплачиваются сверх дневной цены — в каждом объявлении указано, что входит в стоимость."
      },
      "sailboat": {
        "title": "Аренда парусника {{inCity}}",
        "seoTitle": "Аренда парусной лодки {{inCity}} — с капитаном или без",
        "plural": "парусники",
        "count_one": "{{count}} парусник",
        "count_few": "{{count}} парусника",
        "count_many": "{{count}} парусников",
        "count_other": "{{count}} парусника",
        "intro": "Парусник {{inCity}} — это спокойный день под парусом вдоль побережья: с капитаном, если хочется просто отдыхать, или самостоятельно, если у вас есть опыт. Ниже — все парусники {{inCity}} на Click&Boat с ценами и портами отправления.",
        "priceQ": "Сколько стоит аренда парусника {{inCity}}?",
        "licenceQ": "Нужны ли права, чтобы арендовать парусник {{inCity}}?",
        "licenceA": "С капитаном права не нужны. Чтобы выйти в море самостоятельно, владельцы просят подтвердить опыт парусного плавания, а для мотора мощнее 6 л. с. нужны французские права (permis côtier)."
      },
      "catamaran": {
        "title": "Аренда катамарана {{inCity}}",
        "seoTitle": "Аренда катамарана {{inCity}} — на день с капитаном",
        "plural": "катамараны",
        "count_one": "{{count}} катамаран",
        "count_few": "{{count}} катамарана",
        "count_many": "{{count}} катамаранов",
        "count_other": "{{count}} катамарана",
        "intro": "Катамаран устойчив, просторен и идеален для компании: два корпуса, широкая палуба и сетки-батуты, чтобы загорать между заплывами. Большинство катамаранов {{inCity}} сдаются на день с капитаном. Ниже — все они на Click&Boat, с ценами за день и портами отправления.",
        "priceQ": "Сколько стоит аренда катамарана {{inCity}}?",
        "licenceQ": "Нужны ли права, чтобы арендовать катамаран {{inCity}}?",
        "licenceA": "Нет, если брать его с капитаном — так сдаётся большинство катамаранов. Чтобы управлять самому, владелец попросит подтвердить опыт, а для моторов мощнее 6 л. с. нужны французские права (permis côtier)."
      },
      "no-licence": {
        "title": "Аренда лодки без прав {{inCity}}",
        "seoTitle": "Аренда лодки без прав {{inCity}}",
        "plural": "лодки без прав",
        "count_one": "{{count}} лодка без прав",
        "count_few": "{{count}} лодки без прав",
        "count_many": "{{count}} лодок без прав",
        "count_other": "{{count}} лодки без прав",
        "intro": "Нет прав на управление судном? У лодок без прав мотор не мощнее 6 л. с., поэтому во Франции ими может управлять любой после короткого инструктажа владельца. Они медленнее других лодок и держатся у берега — идеально для нескольких часов с купанием {{inCity}}. Ниже — все такие лодки на Click&Boat с ценами и портами отправления.",
        "priceQ": "Сколько стоит аренда лодки без прав {{inCity}}?",
        "licenceQ": "Можно ли {{inCity}} действительно управлять такой лодкой без прав?",
        "licenceA": "Да. Во Франции лодкой с мотором не мощнее 6 л. с. (4,5 кВт) можно управлять без прав; владелец проведёт инструктаж перед выходом. Любую другую лодку можно взять с капитаном — тогда права тоже не нужны."
      }
    }
  },
  "eventsHub": {
    "intro": [
      "Предстоящие концерты, спектакли, стендап, шоу и фестивали Лазурного Берега (Французской Ривьеры) в одном месте — от Ниццы и Канн до Монако, Антиба и Ментона. Афиша обновляется каждый день: у каждого события — даты, площадка, начальная цена и ссылка на покупку билетов у официального продавца."
    ],
    "sections": [
      {
        "heading": "Главные события года на Ривьере",
        "paragraphs": [
          "Год на Ривьере начинается с Международного циркового фестиваля Монте-Карло в январе. В феврале проходят Карнавал в Ницце и Праздник лимонов в Ментоне — два самых известных зимних праздника на юге Франции. В мае Канны принимают кинофестиваль, а в мае–июне в Монако проходит Гран-при «Формулы-1».",
          "Летом культурная жизнь переезжает под открытое небо: в июле — Nice Jazz Festival и Jazz à Juan в Жуан-ле-Пене (Антиб), летними вечерами над Каннской бухтой — международный конкурс фейерверков. С осени до весны — сезон театров, оперы и концертных залов: в это время в афише больше всего спектаклей, стендапа, балета и классической музыки."
        ]
      },
      {
        "heading": "Где проходят концерты и спектакли",
        "paragraphs": [
          "Большие гастрольные концерты и шоу проходят на арене Palais Nikaïa в Ницце и во Дворце фестивалей в Каннах. В Монако главные сцены — Опера Монте-Карло и Grimaldi Forum, в Ницце — Опера Ниццы и Национальный театр Ниццы. Стендап, камерные спектакли и концерты идут в небольших театрах, клубах и казино в каждом городе побережья — точный адрес указан на странице события."
        ]
      },
      {
        "heading": "Как купить билеты",
        "paragraphs": [
          "Откройте событие, чтобы увидеть все даты, площадку и начальную цену. Если шоу идёт несколько раз, все даты собраны на одной странице, и у каждой — своя кнопка «Билеты». Покупка оформляется на сайте официального продавца: там выбираются места и проводится оплата, а цена — та же, что у продавца."
        ]
      }
    ],
    "citiesHeading": "Афиша по городам",
    "faqHeading": "Афиша Лазурного Берега: частые вопросы",
    "faq": [
      {
        "q": "Куда сходить на Лазурном Берегу?",
        "a": "В афише — концерты, спектакли, стендап, шоу и фестивали в Ницце, Каннах, Монако, Антибе, Ментоне и других городах Ривьеры. У каждого города есть своя афиша с полным списком событий по категориям."
      },
      {
        "q": "Когда на Лазурном Берегу больше всего событий?",
        "a": "Театральный и концертный сезон идёт с осени до весны — тогда работают опера, театры и концертные залы. Летом проходят фестивали и концерты под открытым небом, а в январе–феврале — цирковой фестиваль в Монако, Карнавал в Ницце и Праздник лимонов в Ментоне."
      },
      {
        "q": "Нужно ли знать французский язык?",
        "a": "Большинство спектаклей и стендап-шоу идут на французском. Концерты, опера, балет, цирк и музыкальные шоу понятны и без знания языка."
      },
      {
        "q": "Как купить билеты?",
        "a": "Откройте событие и нажмите «Купить билеты» или кнопку «Билеты» у нужной даты — вы перейдёте на сайт официального продавца, где выбираются места и оформляется оплата."
      },
      {
        "q": "Как часто обновляется афиша?",
        "a": "Каждый день: новые события появляются, как только открываются продажи, а прошедшие исчезают из списков."
      }
    ]
  },
  "cityEvents": {
    "cities": {
      "nice": {
        "title": "Афиша Ниццы",
        "seoTitle": "Афиша Ниццы — концерты, спектакли и шоу",
        "intro": [
          "В Ницце самая насыщенная культурная жизнь на Лазурном Берегу. Крупные гастрольные концерты и шоу проходят на арене Palais Nikaïa на западной окраине города, а Опера Ниццы, Национальный театр Ниццы и небольшие сцены вроде Théâtre Lino Ventura и Théâtre de la Cité с осени до весны показывают спектакли, стендап и классическую музыку.",
          "Главные события года — Карнавал в феврале и джазовый фестиваль Nice Jazz Festival в июле. Ниже — все предстоящие мероприятия в Ницце из нашего каталога: сначала ближайшие, затем полный список по категориям, с датой, площадкой и ссылкой на покупку билетов."
        ]
      },
      "cannes": {
        "title": "Афиша Канн",
        "seoTitle": "Афиша Канн — концерты, шоу и фестивали",
        "intro": [
          "Вне дней кинофестиваля культурная жизнь Канн сосредоточена во Дворце фестивалей на Круазетт: в его Théâtre Debussy и Большом зале весь сезон идут спектакли, концерты, балет и юмористические шоу. Камерные постановки дополняют Théâtre Croisette, Théâtre Alexandre III и Espace Miramar.",
          "Летом бухта становится сценой Фестиваля пиротехнического искусства — международного конкурса фейерверков. Ниже — все предстоящие мероприятия в Каннах из нашего каталога, с датами, площадками и ссылками на билеты."
        ]
      },
      "monaco": {
        "title": "Афиша Монако",
        "seoTitle": "Афиша Монако — опера, шоу и концерты",
        "intro": [
          "Для государства площадью два квадратных километра в Монако необычайно богатая культурная программа: опера и балет в зале Гарнье Оперы Монте-Карло, большие шоу и концерты в Grimaldi Forum, спектакли в Théâtre Princesse Grace.",
          "Каждый январь шапито в Фонвьей занимает Международный цирковой фестиваль Монте-Карло, а весной проходит Гран-при. Ниже — все предстоящие мероприятия в Монако из нашего каталога, с датами, площадками и ссылками на билеты."
        ]
      },
      "antibes": {
        "title": "Афиша Антиба",
        "seoTitle": "Афиша Антиба и Жуан-ле-Пена",
        "intro": [
          "Антиб и Жуан-ле-Пен сочетают очарование старого города с живой сценой: современный театр Anthéa весь сезон ставит спектакли, танцевальные программы и концерты, а казино и залы в окрестностях добавляют юмористические вечера и трибьют-шоу.",
          "Каждый июль фестиваль Jazz à Juan — один из старейших джазовых фестивалей Европы — собирает звёзд мировой сцены в сосновой роще Pinède Gould. Ниже — все предстоящие мероприятия в Антибе и окрестностях из нашего каталога, с датами, площадками и ссылками на билеты."
        ]
      },
      "menton": {
        "title": "Афиша Ментона",
        "seoTitle": "Афиша Ментона — концерты, спектакли и фестивали",
        "intro": [
          "Календарь Ментона строится вокруг двух больших событий: Праздника лимонов в феврале, когда сады заполняются гигантскими скульптурами из цитрусовых, и летнего Музыкального фестиваля Ментона с камерной музыкой на площади перед базиликой Сен-Мишель.",
          "В остальное время концерты, спектакли и юмористические шоу проходят во Дворце Европы, казино Barrière и городских церквях. Ниже — все предстоящие мероприятия в Ментоне из нашего каталога, с датами, площадками и ссылками на билеты."
        ]
      },
      "sttropez": {
        "title": "Афиша Сен-Тропе",
        "seoTitle": "Афиша Сен-Тропе — концерты и фестивали",
        "intro": [
          "Сен-Тропе живёт прежде всего летом, когда концерты и вечеринки заполняют порт и пляжи Пампелон. Но местные традиции расписаны на весь год: в мае — Бравада, многовековая процессия в честь покровителя города, а на рубеже сентября и октября — Les Voiles de Saint-Tropez, регата классических и современных яхт.",
          "Вне сезона концерты перебираются в часовни и культурные площадки городка. Ниже — все предстоящие мероприятия в Сен-Тропе из нашего каталога, с датами, площадками и ссылками на билеты."
        ]
      },
      "villefranche": {
        "title": "Афиша Вильфранш-сюр-Мер",
        "seoTitle": "Афиша Вильфранш-сюр-Мер",
        "intro": [
          "Вильфранш-сюр-Мер — небольшой портовый городок, и события здесь в основном местные и сезонные: концерты и выставки в цитадели Сент-Эльм, летние праздники на набережной и, в конце зимы, Цветочная морская битва (Combat Naval Fleuri), когда украшенные лодки проплывают по бухте и бросают цветы зрителям.",
          "За большими концертами и шоу — в Ниццу (десять минут) или в Монако (около двадцати). Ниже — все предстоящие мероприятия в Вильфранше из нашего каталога, с датами, площадками и ссылками на билеты."
        ]
      }
    },
    "metaDescription_one": "{{count}} предстоящее мероприятие {{inCity}}: {{list}}. Даты, площадки и билеты, обновляется ежедневно.",
    "metaDescription_few": "{{count}} предстоящих мероприятия {{inCity}}: {{list}}. Даты, площадки и билеты, обновляется ежедневно.",
    "metaDescription_many": "{{count}} предстоящих мероприятий {{inCity}}: {{list}}. Даты, площадки и билеты, обновляется ежедневно.",
    "metaDescription_other": "{{count}} предстоящих мероприятия {{inCity}}: {{list}}. Даты, площадки и билеты, обновляется ежедневно.",
    "stats_one": "{{count}} предстоящее мероприятие",
    "stats_few": "{{count}} предстоящих мероприятия",
    "stats_many": "{{count}} предстоящих мероприятий",
    "stats_other": "{{count}} предстоящих мероприятия",
    "priceStat": "билеты от {{price}}",
    "citiesHeading": "Афиша других городов Лазурного Берега",
    "nextHeading": "Ближайшие мероприятия {{inCity}}",
    "allHeading": "Все предстоящие мероприятия {{inCity}}",
    "venuesHeading": "Площадки",
    "faqHeading": "Мероприятия {{inCity}}: частые вопросы",
    "showAll": "Показать все ({{count}})",
    "showFewer": "Свернуть",
    "allEvents": "Все мероприятия на Лазурном Берегу",
    "loading": "Загрузка мероприятий…",
    "empty": "Предстоящих мероприятий не найдено.",
    "listSeparator": ", ",
    "faq": {
      "whatQ": "Куда сходить {{inCity}}?",
      "whatA": "В нашем каталоге — предстоящие мероприятия {{inCity}} с {{first}} по {{last}} (всего: {{count}}): {{list}}. Список обновляется ежедневно, по мере открытия продаж.",
      "venuesQ": "Где проходят концерты и спектакли {{inCity}}?",
      "venuesA": "Больше всего предстоящих мероприятий {{inCity}} на площадках: {{list}}.",
      "ticketsQ": "Как купить билеты на мероприятия {{inCity}}?",
      "ticketsA": "Откройте мероприятие, чтобы увидеть дату, время, площадку и начальную цену, а затем перейдите по ссылке на билеты, чтобы купить их у официального продавца.",
      "ticketsPriceA": "Билеты на мероприятия {{inCity}} — от {{price}}. Откройте мероприятие, чтобы увидеть дату, время, площадку и начальную цену, а затем перейдите по ссылке на билеты, чтобы купить их у официального продавца."
    }
  },
  "cityEventSlices": {
    "windows": {
      "today": {
        "title": "Куда сходить {{inCity}} сегодня",
        "when": "сегодня",
        "label": "Сегодня"
      },
      "this-weekend": {
        "title": "Куда сходить {{inCity}} на выходных",
        "when": "в эти выходные",
        "label": "На выходных"
      },
      "this-week": {
        "title": "Куда сходить {{inCity}} на этой неделе",
        "when": "в ближайшие 7 дней",
        "label": "На этой неделе"
      }
    },
    "categoryTitle": "{{category}} {{inCity}}",
    "categoryAnswer": "{{title}}: {{stats}}, {{range}}.",
    "windowCount_one": "{{count}} мероприятие {{inCity}} {{when}}",
    "windowCount_few": "{{count}} мероприятия {{inCity}} {{when}}",
    "windowCount_many": "{{count}} мероприятий {{inCity}} {{when}}",
    "windowCount_other": "{{count}} мероприятия {{inCity}} {{when}}",
    "range": "с {{first}} по {{last}}",
    "highlights": "В программе: {{list}}.",
    "empty": "Пока {{inCity}} {{when}} ничего не запланировано.",
    "allHeading_one": "{{count}} мероприятие",
    "allHeading_few": "Все мероприятия ({{count}})",
    "allHeading_many": "Все мероприятия ({{count}})",
    "allHeading_other": "Все мероприятия ({{count}})",
    "updated": "Обновлено {{date}}",
    "browseHeading": "Афиша {{inCity}} по датам и жанрам",
    "allInCity": "Вся афиша",
    "loading": "Загрузка мероприятий…"
  },
  "toursHub": {
    "intro": [
      "Экскурсии, однодневные поездки и впечатления на Лазурном Берегу (Французской Ривьере) с отправлением из Ниццы, Канн, Монако, Антиба, Сен-Тропе, Ментона и Вильфранш-сюр-Мер. У каждой экскурсии указаны продолжительность, оценка путешественников, начальная цена и ссылка на бронирование через Viator."
    ],
    "sections": [
      {
        "heading": "Главные экскурсии Ривьеры",
        "paragraphs": [
          "Самая известная поездка на Ривьере идёт вдоль побережья на восток от Ниццы: средневековая деревня Эз на скале, затем Монако и Монте-Карло — Княжеский дворец и старый город на Скале, казино и трасса Гран-при. Вглубь материка экскурсии едут в Сен-Поль-де-Ванс с его художественными галереями и в Грас — столицу парфюмерии, а летом дальше в Прованс — к лавандовым полям и ущелью Вердон.",
          "На западе Сен-Тропе и красные скалы Эстереля — это поездка на целый день из Канн или Ниццы, а на востоке Ментон — последняя остановка перед итальянской границей."
        ]
      },
      {
        "heading": "Экскурсии по интересам",
        "paragraphs": [
          "Помимо обзорных экскурсий — винные дегустации на виноградниках Белле и Кот-де-Прованс, гастрономические прогулки по рынкам и старым кварталам, морские прогулки и снорклинг вдоль побережья, туры на электровелосипедах и пешеходные экскурсии по городам. Индивидуальные туры с гидом-водителем здесь очень популярны: так проще всего объехать несколько деревень за день, и это частый выбор пассажиров круизных лайнеров, которые заходят в Вильфранш-сюр-Мер и Монако."
        ]
      },
      {
        "heading": "Как забронировать",
        "paragraphs": [
          "Экскурсии бронируются на Viator: сайт принимает оплату и присылает подтверждение с местом встречи. Во многие поездки из Ниццы и Канн входит трансфер от отеля, а во многих действует бесплатная отмена за 24 часа до начала — и то и другое указано в каждой экскурсии до бронирования."
        ]
      }
    ],
    "citiesHeading": "Экскурсии по городам",
    "faqHeading": "Экскурсии по Лазурному Берегу: частые вопросы",
    "faq": [
      {
        "q": "Какие экскурсии на Лазурном Берегу самые интересные?",
        "a": "Классика — Эз и Монако на побережье к востоку от Ниццы, Сен-Поль-де-Ванс и Грас вглубь материка, Сен-Тропе на западе. Летом популярны поездки на целый день к лавандовым полям Прованса и в ущелье Вердон."
      },
      {
        "q": "Групповая или индивидуальная экскурсия?",
        "a": "Экскурсии в небольших группах — самый недорогой способ увидеть главные места. Индивидуальный тур с гидом-водителем стоит дороже, зато темп и маршрут выбираете вы — это удобно для семей, чтобы успеть несколько деревень за день, и для круизных пассажиров с жёстким расписанием."
      },
      {
        "q": "Нужна ли машина?",
        "a": "Нет. Трансфер входит в однодневные поездки, а многие из них забирают туристов от отеля или из центральной точки встречи в Ницце или Каннах. Между городами побережья удобно ездить и на региональном поезде вдоль моря."
      },
      {
        "q": "Есть ли экскурсии на русском языке?",
        "a": "Большинство групповых экскурсий проводятся на английском, некоторые — на французском или других языках; языки гида указаны на Viator. Если нужен гид, говорящий по-русски, проще всего выбрать индивидуальный тур и уточнить язык у организатора до бронирования."
      },
      {
        "q": "Можно ли отменить бронирование?",
        "a": "Во многих экскурсиях действует бесплатная отмена за 24 часа до начала, но условия различаются — они указаны в каждой экскурсии до бронирования на Viator."
      },
      {
        "q": "Как отсортированы экскурсии?",
        "a": "По отзывам путешественников: чем больше отзывов подтверждают оценку, тем больше она весит, поэтому экскурсия с сотнями хороших отзывов стоит выше идеальной оценки по нескольким отзывам."
      }
    ]
  },
  "hubFilters": {
    "sort": "Сортировка",
    "reset": "Сбросить фильтры",
    "retry": "Повторить",
    "loadError": "Не удалось загрузить результаты. Попробуйте ещё раз.",
    "noResults": "По этим фильтрам ничего не найдено.",
    "sortOptions": {
      "recommended": "Рекомендуемые",
      "price_asc": "Сначала дешевле",
      "price_desc": "Сначала дороже",
      "reviews": "Больше отзывов",
      "newest": "Год постройки: сначала новые",
      "soonest": "Сначала ближайшие"
    },
    "sortBuildYear": "Год постройки",
    "duration": "Длительность",
    "durationOptions": {
      "any": "Любая",
      "short": "До 3 часов",
      "half": "3–6 часов",
      "full": "Больше 6 часов"
    },
    "when": "Когда",
    "whenOptions": {
      "any": "Любые даты",
      "today": "Сегодня",
      "tomorrow": "Завтра",
      "weekend": "В эти выходные",
      "week": "Ближайшие 7 дней",
      "month": "Ближайшие 30 дней"
    },
    "category": "Категория",
    "format": "Формат",
    "formatOptions": {
      "any": "Индивидуальные и групповые",
      "group": "Групповые",
      "private": "Индивидуальные"
    },
    "price": "Цена",
    "pricePerDay": "Цена в день",
    "priceAny": "Любая цена",
    "priceUnder": "До {{price}}",
    "priceBetween": "{{min}}–{{max}}",
    "priceOver": "От {{price}}",
    "boatType": "Тип лодки",
    "boatTypeOptions": {
      "any": "Все лодки",
      "motorboat": "Моторные лодки",
      "rib": "РИБы",
      "yacht": "Яхты",
      "sailboat": "Парусники",
      "catamaran": "Катамараны",
      "nolicence": "Без прав"
    },
    "toursCount_one": "{{count}} тур",
    "toursCount_few": "{{count}} тура",
    "toursCount_many": "{{count}} туров",
    "toursCount_other": "{{count}} тура",
    "boatsCount_one": "{{count}} лодка",
    "boatsCount_few": "{{count}} лодки",
    "boatsCount_many": "{{count}} лодок",
    "boatsCount_other": "{{count}} лодки",
    "eventsCount_one": "{{count}} событие",
    "eventsCount_few": "{{count}} события",
    "eventsCount_many": "{{count}} событий",
    "eventsCount_other": "{{count}} события"
  },
  "cityTours": {
    "cities": {
      "nice": {
        "title": "Экскурсии в Ницце",
        "seoTitle": "Экскурсии в Ницце — пешеходные и гастрономические туры",
        "intro": [
          "Ницца — главная отправная точка для экскурсий по Лазурному Берегу. В самом городе классика — пешеходная или гастрономическая прогулка по Старой Ницце (сокка, писсаладьер, рынок на Кур-Салея) и поездки на велосипеде или сегвее по Английской набережной до Замковой горы.",
          "Из Ниццы экскурсии на полдня и на целый день уходят на восток по корнишам в Эз и Монако, на запад — в Сен-Поль-де-Ванс и Грас, а вглубь страны — до ущелья Вердон. Ниже — все экскурсии в Ницце из нашего каталога, сгруппированные по продолжительности и отсортированные по оценкам путешественников."
        ]
      },
      "cannes": {
        "title": "Экскурсии в Каннах",
        "seoTitle": "Экскурсии в Каннах — Леринские острова и старый город",
        "intro": [
          "Самые популярные полудневные экскурсии в Каннах — морские: из старого порта отходят кораблики на Леринские острова, где на острове Сент-Маргерит стоит форт Железной маски, а на острове Сент-Онора — действующий монастырь с собственным виноградником. На суше пешеходные экскурсии поднимаются от Круазетт в Сюке — старый квартал.",
          "Из Канн легко добраться до Граса с его парфюмерными фабриками, красных скал Эстереля и горных деревень. Ниже — все экскурсии в Каннах из нашего каталога, сгруппированные по продолжительности и отсортированные по оценкам путешественников."
        ]
      },
      "monaco": {
        "title": "Экскурсии в Монако",
        "seoTitle": "Экскурсии в Монако — дворец, казино и Монте-Карло",
        "intro": [
          "Монако достаточно компактно, чтобы обойти его пешком: экскурсии обычно объединяют Скалу — Княжеский дворец, собор и Океанографический музей — с площадью казино Монте-Карло и участком трассы Формулы-1.",
          "Из Монако удобно ездить вдоль побережья в Эз и Ментон или через границу на Итальянскую Ривьеру. Ниже — все экскурсии в Монако из нашего каталога, сгруппированные по продолжительности и отсортированные по оценкам путешественников."
        ]
      },
      "antibes": {
        "title": "Экскурсии в Антибе",
        "seoTitle": "Экскурсии в Антибе — старый город и мыс Антиб",
        "intro": [
          "Антиб сочетает старый город в крепостных стенах с одним из красивейших побережий Лазурного Берега. Экскурсии проходят по крепостным валам, провансальскому рынку и музею Пикассо в замке Гримальди или по прибрежной тропе вокруг мыса Антиб.",
          "Из Антиба недалеко до Сен-Поль-де-Ванса, Граса и Канн, а морские прогулки отправляются из Порт-Вобана — одной из крупнейших яхтенных гаваней Европы. Ниже — все экскурсии в Антибе из нашего каталога, сгруппированные по продолжительности и отсортированные по оценкам путешественников."
        ]
      },
      "menton": {
        "title": "Экскурсии в Ментоне",
        "seoTitle": "Экскурсии в Ментоне — сады, старый город и Италия",
        "intro": [
          "Ментон — город-сад Лазурного Берега: в мягком климате лимоны и субтропические растения растут под открытым небом, а экскурсии открывают сады Валь-Рамэ и Серр-де-ла-Мадон. Пешеходные маршруты поднимаются по лестницам старого города к базилике Сен-Мишель.",
          "Италия начинается на окраине города, поэтому многие экскурсии из Ментона пересекают границу — на пятничный рынок в Вентимилье, в Дольчеакву или Сан-Ремо, — а другие направляются в Монако и Эз. Ниже — все экскурсии в Ментоне из нашего каталога, сгруппированные по продолжительности и отсортированные по оценкам путешественников."
        ]
      },
      "sttropez": {
        "title": "Экскурсии в Сен-Тропе",
        "seoTitle": "Экскурсии в Сен-Тропе — морские прогулки и винные туры",
        "intro": [
          "Сен-Тропе лучше всего смотреть с моря: морские прогулки идут вдоль вилл бухты Канебье и пляжей Пампелон. На суше порт, Цитадель и площадь Лис — готовый маршрут для пешеходной экскурсии.",
          "Полуостров — ещё и край розовых вин, поэтому дегустации на виноградниках Раматюэля и Гассена — одни из самых популярных впечатлений, как и поездки в горные деревни и на Йерские острова. Ниже — все экскурсии в Сен-Тропе из нашего каталога, сгруппированные по продолжительности и отсортированные по оценкам путешественников."
        ]
      },
      "villefranche": {
        "title": "Экскурсии в Вильфранш-сюр-Мер",
        "seoTitle": "Экскурсии из Вильфранш-сюр-Мер для круизных туристов",
        "intro": [
          "Вильфранш-сюр-Мер — один из самых загруженных круизных портов Средиземноморья, поэтому многие экскурсии здесь рассчитаны на стоянку лайнера: Монако, Эз и Ницца за один день или короткий маршрут по мысу Ферра с виллой Эфрусси де Ротшильд.",
          "Если вы живёте в городе, порт, цитадель и Тёмная улица (Rue Obscure) — средневековая крытая улица — входят в пешеходные экскурсии. Ниже — все экскурсии в Вильфранше из нашего каталога, сгруппированные по продолжительности и отсортированные по оценкам путешественников."
        ]
      }
    },
    "metaDescription_one": "{{count}} экскурсия {{inCity}} от {{price}} с человека — с оценками путешественников и бронированием на Viator.",
    "metaDescription_few": "Сравните {{count}} экскурсии {{inCity}} от {{price}} с человека: короткие прогулки, туры на полдня и на весь день, с оценками путешественников. Бронирование на Viator.",
    "metaDescription_many": "Сравните {{count}} экскурсий {{inCity}} от {{price}} с человека: короткие прогулки, туры на полдня и на весь день, с оценками путешественников. Бронирование на Viator.",
    "metaDescription_other": "Сравните {{count}} экскурсии {{inCity}} от {{price}} с человека: короткие прогулки, туры на полдня и на весь день, с оценками путешественников. Бронирование на Viator.",
    "stats_one": "{{count}} экскурсия",
    "stats_few": "{{count}} экскурсии",
    "stats_many": "{{count}} экскурсий",
    "stats_other": "{{count}} экскурсии",
    "priceStat": "от {{price}} с человека",
    "ratingStat": "средняя оценка {{rating}}/5",
    "citiesHeading": "Экскурсии в других городах Лазурного Берега",
    "durations": {
      "short": "Короткие экскурсии (до 3 часов)",
      "halfDay": "Экскурсии на полдня (3–6 часов)",
      "fullDay": "Экскурсии на весь день",
      "unknown": "Другие впечатления"
    },
    "faqHeading": "Экскурсии {{inCity}}: частые вопросы",
    "allTours": "Все экскурсии на Лазурном Берегу",
    "loading": "Загрузка экскурсий…",
    "empty": "Экскурсий не найдено.",
    "listSeparator": "; ",
    "faq": {
      "priceQ": "Сколько стоит экскурсия {{inCity}}?",
      "priceA": "Экскурсии {{inCity}} — от {{min}} с человека, половина из них стоит {{median}} или меньше. Индивидуальные экскурсии и поездки на весь день с транспортом дороже — в каждом предложении на Viator указано, что входит в стоимость.",
      "bestQ": "Какие экскурсии {{inCity}} самые популярные?",
      "bestA": "Экскурсии {{inCity}} с самыми высокими оценками путешественников: {{list}}.",
      "bestItem": "{{title}} ({{rating}}/5, отзывов: {{reviews}})",
      "durationQ": "Сколько длятся экскурсии {{inCity}}?",
      "durationA": "Всего в каталоге экскурсий {{inCity}}: {{count}}. По продолжительности: {{list}}.",
      "bookQ": "Как забронировать экскурсию {{inCity}}?",
      "bookA": "Все экскурсии здесь бронируются на Viator — там указаны актуальное наличие мест, место встречи или трансфера и условия отмены для выбранной даты."
    }
  },
  "footer": {
    "sisterSites": "Наши другие гиды:",
    "tagline": "События, экскурсии, винные дегустации и аренда лодок на Лазурном Берегу — Ницца, Канны, Монако, Антиб, Сен-Тропе, Ментон и Вильфранш-сюр-Мер.",
    "thingsToDo": "Чем заняться",
    "events": "Афиша",
    "tours": "Экскурсии",
    "boatRental": "Аренда лодок",
    "wineTours": "Винные туры",
    "language": "Язык",
    "disclosure": "Riviera To-Do — независимый гид. Некоторые ссылки партнёрские: при бронировании у наших партнёров (Viator, Fnac Spectacles, Click&Boat) мы можем получить комиссию — для вас цена не меняется."
  }
}
